import { Reveal } from 'react-awesome-reveal';
import classnames from 'classnames';
import fadeInDown from 'components/animations/fadeInDown';
import ExperienceARButton from 'components/experience-ar-button';
import lang from 'constants/lang';
import translations from 'constants/home';
import KeyVisual from '../key-visual-video';
import styles from './Top.module.scss';

function Top({ loading, setLoading, setPage }) {
  return (
    <>
      <section className={ styles.container }>
        <div className={ styles.keyVisual }>
          <KeyVisual
            loading={ loading }
            setLoading={ setLoading }
          />
        </div>
      </section>

      <div className={ styles.placeholder } />

      <ExperienceARButton
        setPage={ setPage }
        className={ classnames(styles.experience, styles[lang]) }
      />

      <Reveal keyframes={ fadeInDown } duration={ 1000 } triggerOnce>
        <div className={ styles.viewMore }>
          <span>{ translations.viewMore }</span><br />
          <Reveal keyframes={ fadeInDown } delay={ 500 } duration={ 1000 } triggerOnce>
            <img src={ `${process.env.PUBLIC_URL}/images/arrow-down.svg` } alt="" />
          </Reveal>
        </div>
      </Reveal>
    </>
  );
}

export default Top;